import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import { KLoader } from "@kyburz/kdesign-system";

import { Config } from "../Config";
import DeviceConfigDetails from "../device-config-details/DeviceConfigDetails";
import { editConfig, getConfig } from "../../../apiCalls/config/config";
import { setAlert } from "../../../redux/actions/actions";
import { formatErrorResponse } from "../../../utils/stringUtils";

const EditDeviceConfigPage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [initialConfig, setInitialConfig] = useState<Config | null>(null);

  const match = useRouteMatch<{ configId?: string; tab?: string }>({
    path: "/config/devices/config/:configId/*",
    strict: true,
    sensitive: true,
  });

  const { configId } = match?.params || {};

  useEffect(() => {
    if (!configId) return;
    getConfig(configId)
      .then((res: any) => {
        setInitialConfig({
          id: res?.data?.id,
          hardwareType: res?.data?.hardware_type,
          version: res?.data?.version,
          description: res?.data?.description,
          tags: res?.data?.tags || [],
          allowedCustomers: res?.data?.allowed_customers,
          simType: res?.data?.sim_type,
          contentsBase64: res?.data?.contents?.Bytes,
        });
      })
      .catch(() => {
        dispatch(setAlert("Couldn't get device config", "error"));
      });
  }, [configId]);

  const goBack = () => {
    history.push("/config/devices/config");
  };

  const handleEdit = async (updatedConfig: Config) => {
    setLoading(true);
    const res = await editConfig({
      ...updatedConfig,
      contentsBase64:
        updatedConfig?.contentsBase64?.split("base64,").pop() || null,
    });
    setLoading(false);
    if (res.data) {
      dispatch(setAlert(`Config ${updatedConfig.version} edited`, "success"));
      goBack();
    } else {
      dispatch(setAlert(formatErrorResponse(res), "error"));
    }
  };

  if (!initialConfig) return <KLoader />;

  return (
    <DeviceConfigDetails
      initialConfig={initialConfig}
      title="Edit configuration"
      isLoading={loading}
      handleSave={handleEdit}
      handleCancel={goBack}
    />
  );
};

export default EditDeviceConfigPage;
